module.exports = __webpack_public_path__ + "static/media/long-arrow-down.c3d521d3.svg";